// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelViewItem-Value_cls1__DhU3Q","cls2":"PaymentChannelViewItem-Value_cls2__a+bLr PaymentChannelViewItem-Value_cls1__DhU3Q"};